








import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import queryCom from "./components/queryCom.vue";
import tabCom from "./components/tabCom.vue";
@Component({
  components: {
    headerTitle,
    queryCom,
    tabCom,
  },
})
export default class Home extends Vue {
  public returnList(data) {
    const $tabCom: any = this.$refs.tabCom;
    $tabCom.parentList(data);
  }
}
